// The Accelerator's Group page (/accelerator/group; no board draws it, so its words are listed for
// Adam): Your group, with the group's own WhatsApp link, as the home's card (Accelerator.dc.html),
// then the member directory of the whole Accelerator, every group (Adam's answer 1 of 7 Oct): the
// members who've switched it on in Account, with their photo, their group, where they invest and
// about them (Account.dc.html's fields; Adam, 2 Oct). Never an email or phone. The eyebrow is their
// group with its schedule ("Group 2, monthly, Sundays"). A member Adam hasn't put in a group yet sees
// the line that says so, and the directory, which is the Accelerator's, not a group's.
import { useViewingAs } from '../../lib/viewAs.jsx'
import { useProductData } from '../../product/ProductData.jsx'
import { myIntake, nameWithSchedule } from '../../product/model.js'
import { GroupCard } from '../../products/accelerator/Cards.jsx'
import { Directory } from '../../products/accelerator/Directory.jsx'
import { LoadFailed, Loading, useAccelerator } from '../../products/accelerator/Page.jsx'
import { COPY } from '../../products/accelerator/copy.js'
import { standingFor } from '../../products/accelerator/model.js'

export default function MastermindGroup({ product }) {
  const { data } = useProductData()
  const viewingAs = useViewingAs()
  const mm = useAccelerator(product)
  if (mm.status === 'loading') return <Loading />
  if (mm.status === 'error' || !mm.data) return <LoadFailed onRetry={mm.reload} />

  const p = data.product || product
  const standing = standingFor(mm.data.standing, p.id)
  const intake = myIntake(data)
  const group = standing?.cohort_name || intake?.name || null

  return (
    <div className="acc-page acc-page--group">
      <section className="pl-head">
        {group && <div className="pl-eyebrow">{nameWithSchedule(group, intake?.name === group ? intake.schedule_label : null)}</div>}
        <h1 className="pl-h1">{COPY.groupH1}</h1>
      </section>
      <GroupCard group={group} url={data.whatsappUrl} />
      <Directory productId={p.id} productName={p.name} viewingAs={viewingAs} />
    </div>
  )
}
